import './index.scss';
import React from 'react';
import { Check } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { LoungeResource } from '../../../../store/lounges/loungesManagementTypes';
import { MyActivityAllocDto } from '../../../../API/room/dto/response/my-activity-alloc.dto';
import LoadGauge from '../../book-room/LoadGauge';
import { UseFormReturn } from 'react-hook-form';

type PropsTypes = {
  lounge: LoungeResource;
  alloc?: MyActivityAllocDto;
  form: UseFormReturn<any, object>;
};

const BookLoungeInfo = ({ alloc, form, ...props }: PropsTypes) => {
  const { t } = useTranslation();
  const defaultImage =
    '//cdn.pixabay.com/photo/2017/03/28/12/17/chairs-2181994__340.jpg';

  return (
    <div className="book-lounge-modal-general">
      <div className="book-lounge-general-name">{props.lounge.name}</div>
      <div className="book-lounge-general-image">
        <img src={props.lounge.image || defaultImage} alt="room image" />
      </div>
      <div className="book-lounge-gouge">
        <LoadGauge
          start={form.watch('start')}
          end={form.watch('end')}
          openFrom={props.lounge.availableFrom}
          openTo={props.lounge.availableTo}
          date={form.watch('date')}
          minBookingTime={props.lounge.minimumBookingTime}
        />
      </div>
      <div className="book-lounge-general-description">
        {props.lounge.description}
      </div>
      <div className="book-lounge-general-description"></div>
      {props.lounge.equipment && Boolean(props.lounge.equipment.length) && (
        <div className="book-lounge-general-amenities">
          <div className="book-lounge-general-amenities-title">
            {t('MAIN_AMENITIES')}
          </div>
          <div className="book-lounge-general-amenities-items">
            {props.lounge.equipment &&
              props.lounge.equipment.map((item, index) => (
                <div className="book-lounge-general-amenities-item" key={index}>
                  <Check />
                  {item}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default BookLoungeInfo;
